/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NaturePlantTreePalmIcon16Light } from './NaturePlantTreePalmIcon16Light';
import { NaturePlantTreePalmIcon16Regular } from './NaturePlantTreePalmIcon16Regular';
import { NaturePlantTreePalmIcon16Solid } from './NaturePlantTreePalmIcon16Solid';
import { NaturePlantTreePalmIcon20Light } from './NaturePlantTreePalmIcon20Light';
import { NaturePlantTreePalmIcon20Regular } from './NaturePlantTreePalmIcon20Regular';
import { NaturePlantTreePalmIcon20Solid } from './NaturePlantTreePalmIcon20Solid';
import { NaturePlantTreePalmIcon24Regular } from './NaturePlantTreePalmIcon24Regular';
import { NaturePlantTreePalmIcon24Solid } from './NaturePlantTreePalmIcon24Solid';
import { NaturePlantTreePalmIcon32Regular } from './NaturePlantTreePalmIcon32Regular';
import { NaturePlantTreePalmIcon64Regular } from './NaturePlantTreePalmIcon64Regular';
var sizes = {
    16: {
        light: NaturePlantTreePalmIcon16Light,
        regular: NaturePlantTreePalmIcon16Regular,
        solid: NaturePlantTreePalmIcon16Solid,
    },
    20: {
        light: NaturePlantTreePalmIcon20Light,
        regular: NaturePlantTreePalmIcon20Regular,
        solid: NaturePlantTreePalmIcon20Solid,
    },
    24: {
        regular: NaturePlantTreePalmIcon24Regular,
        solid: NaturePlantTreePalmIcon24Solid,
    },
    32: {
        regular: NaturePlantTreePalmIcon32Regular,
    },
    64: {
        regular: NaturePlantTreePalmIcon64Regular,
    },
};
export var NaturePlantTreePalmIcon = forwardRef('NaturePlantTreePalmIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
